(function ($) {
  DJ.addBehavior('addMediaQuestions', '.media-brio-media-modal-add-form', {
    attach: function () {
      const questionsHolder = this;
      const question1 = questionsHolder.querySelector('.field--name-field-question-1');
      const question2 = questionsHolder.querySelector('.field--name-field-question-2');
      const question3 = questionsHolder.querySelector('.field--name-field-question-3');
      const question4 = questionsHolder.querySelector('.field--name-field-question-4');
      const nonRespectedRulesBlock = questionsHolder.querySelector('.add-media__non-respected-rules');
      const validateButton = questionsHolder.querySelector('.form-actions .button--primary.js-form-submit');
      const addMediaFile = questionsHolder.querySelectorAll('.add-media__file');
      const downloadsDescription = questionsHolder.querySelector('.add-media__downloads-description');

      // return false if no questions
      if (!question1 && !question2 && !question3 && !question4) {
        return false;
      }

      // disable validation button.
      if (validateButton) {
        validateButton.setAttribute('disabled', '');
      }

      // uncheck radios and refresh jcf plugin.
      const refreshRadios = (radiosToRefresh) => {
        if (radiosToRefresh.length > 0) {
          const elementsArr = Array.prototype.slice.call(radiosToRefresh);

          elementsArr.forEach((e) => {
            e.checked = false;
          });

          jcf.refresh($(radiosToRefresh));
        }
      };

      // question 1 event
      const question1Event = (questionRadio) => {
        const otherQuestionsRadio = questionsHolder.querySelectorAll('.form-radio:not(.field--name-field-question-1 .form-radio)');

        refreshRadios(otherQuestionsRadio);

        if (nonRespectedRulesBlock) {
          nonRespectedRulesBlock.style.display = 'none';
        }

        if (validateButton) {
          validateButton.setAttribute('disabled', '');
        }

        question4.style.display = 'none';

        if (nonRespectedRulesBlock) {
          nonRespectedRulesBlock.style.display = 'none';
        }

        if (addMediaFile.length > 0) {
          Array.prototype.slice.call(addMediaFile).forEach((e) => {
            e.style.display = 'none';
          });
        }

        if (downloadsDescription) {
          downloadsDescription.style.display = 'none';
        }

        if (questionRadio.value === '1') {
          question3.style.display = 'block';
          question2.style.display = 'none';
        } else {
          question3.style.display = 'none';
          question2.style.display = 'block';
        }
      };

      // question 2 event
      const question2Event = (questionRadio) => {
        const otherQuestionsRadio = questionsHolder
          .querySelectorAll('.form-radio:not(.field--name-field-question-1 .form-radio):not(.field--name-field-question-2 .form-radio)');

        refreshRadios(otherQuestionsRadio);

        if (nonRespectedRulesBlock) {
          nonRespectedRulesBlock.style.display = 'none';
        }

        if (addMediaFile.length > 0) {
          Array.prototype.slice.call(addMediaFile).forEach((e) => {
            e.style.display = 'none';
          });
        }

        if (downloadsDescription) {
          downloadsDescription.style.display = 'none';
        }

        if (questionRadio.value === '1') {
          question3.style.display = 'block';

          if (nonRespectedRulesBlock) {
            nonRespectedRulesBlock.style.display = 'none';
          }
        } else {
          question3.style.display = 'none';
          validateButton.setAttribute('disabled', '');

          if (nonRespectedRulesBlock) {
            nonRespectedRulesBlock.style.display = 'block';
          }
        }
      };

      // question 3 event
      const question3Event = (questionRadio) => {
        const otherQuestionsRadio = questionsHolder
          .querySelectorAll('.form-radio:not(.field--name-field-question-1 .form-radio)'
            + ':not(.field--name-field-question-2 .form-radio)'
            + ':not(.field--name-field-question-3 .form-radio)');

        refreshRadios(otherQuestionsRadio);

        if (nonRespectedRulesBlock) {
          nonRespectedRulesBlock.style.display = 'none';
        }

        if (addMediaFile.length > 0) {
          Array.prototype.slice.call(addMediaFile).forEach((e) => {
            e.style.display = 'none';
          });
        }

        if (downloadsDescription) {
          downloadsDescription.style.display = 'none';
        }

        if (questionRadio.value === '1') {
          question4.style.display = 'block';

          if (validateButton) {
            validateButton.setAttribute('disabled', '');
          }
        } else {
          question4.style.display = 'none';

          if (validateButton) {
            validateButton.removeAttribute('disabled');
          }
        }
      };

      // question 4 event
      const question4Event = (questionRadio) => {
        if (questionRadio.value === '1') {
          if (validateButton) {
            validateButton.removeAttribute('disabled');
          }

          if (nonRespectedRulesBlock) {
            nonRespectedRulesBlock.style.display = 'none';
          }

          if (addMediaFile.length > 0) {
            Array.prototype.slice.call(addMediaFile).forEach((e) => {
              e.style.display = 'none';
            });
          }

          if (downloadsDescription) {
            downloadsDescription.style.display = 'none';
          }
        } else {
          if (validateButton) {
            validateButton.setAttribute('disabled', '');
          }

          if (addMediaFile.length > 0) {
            Array.prototype.slice.call(addMediaFile).forEach((e) => {
              e.style.display = 'block';
            });
          }

          if (downloadsDescription) {
            downloadsDescription.style.display = 'block';
          }
        }
      };

      /**
       * Add event listener 'change' to radio buttons.
       * @param question
       *    Question selector.
       * @param isInit
       *    is function used for global first init or for question elements.
       * @param questionEvent
       *    event to bind on radio buttons.
       */
      const questionOnChange = (question, isInit, questionEvent) => {
        const questionsRadio = question.querySelectorAll('.form-radio');

        if (questionsRadio.length === 0) {
          return false;
        }

        const elementsArr = Array.prototype.slice.call(questionsRadio);

        elementsArr.forEach((e) => {
          if (isInit) {
            e.checked = false;
          } else {
            e.addEventListener('change', () => {
              questionEvent(e);
            });
          }
        });

        if (isInit) {
          jcf.refresh($(questionsRadio));
        }

        return true;
      };

      // first init of the questions. Uncheck all radios.
      questionOnChange(questionsHolder, true);

      // question 1 init
      questionOnChange(question1, false, question1Event);

      // question 2 init
      questionOnChange(question2, false, question2Event);

      // question 3 init
      questionOnChange(question3, false, question3Event);

      // question 4 init
      questionOnChange(question4, false, question4Event);

      return true;
    }
  });
})(jQuery);
